import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { ConfigService } from 'app/_services/config.service';
import { shareReplay } from 'rxjs/operators';
import { AuthService } from 'app/_services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private config: ConfigService, private authService: AuthService, private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const self = this;
        const result = next.handle(request).pipe(shareReplay());

        result.pipe().subscribe(
            (httpEvent: HttpEvent<any>) => {
                if (httpEvent.type == HttpEventType.Response && httpEvent.status !== 503 && !httpEvent.headers.has('maintenance'))
                    self.config.changeSystemStatus(true);
            },
            (error) => {
                // Check for Maintenance header
                const maintenanceMode = error.headers.get('maintenance');

                if ([401, 403].indexOf(error.status) !== -1) {
                    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                    self.authService.Logout(false, error.error);
                }

                // If Maintenance Mode is active, redirect to Maintenance page
                if ([503].indexOf(error.status) !== -1 && maintenanceMode && maintenanceMode === 'active') {
                    self.router.navigate([RoutePath.Maintenance]);
                    self.config.changeSystemStatus(false);
                    error.message = 'Site down for maintenance. Please check again later.';
                }
            }
        );

        return result;
    }
}
